const TextAreaVariant = {
  FullWidth: 'fullWidth',
  Default: '_default',
};

export default TextAreaVariant;
